/*
  Klaviyo teaser guard on product, cart, home and collection pages (mobile optimisation Task 2 and the final fix round,
  audit C1). Loaded on those templates only.
  Below 750px assets/cryo-mobile.css pins the teaser bottom-right (above the sticky add-to-cart bar on product and cart
  pages). While the teaser would sit over something that page must keep clear (TARGETS below, per template), this adds
  `cryo-teaser-hold` to <body>, which hides it.
  The teaser stays hidden until its first check has run (`cryo-teaser-ready`), and the fade is only switched on after
  that, so a teaser that should be held never shows, not even for one frame. Klaviyo can insert or replace the teaser
  at any time, so a new teaser element goes through the same first check.
  Checked on scroll (the page, or any scroller such as the homepage product slider) and resize (rAF-throttled) and
  when the DOM changes.
*/
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  // Product cards on the homepage "Find your flavour" slider and on collection pages.
  var CARDS = [
    '.card-wrapper .card__media',
    '.card-wrapper .card__heading',
    '.card-wrapper .price',
    '.card-wrapper .quick-add__submit',
  ];
  var TARGETS_BY_TEMPLATE = {
    'cryo-product-template': [
      'product-info .product__title',
      'product-info [id^="price-"]',
      'product-info variant-selects',
      'product-info .sealsubs-target-element',
      // Subscribe vs one-time tiles and frequency (PDP CRO batch Task 4); they sit outside Seal's target element.
      'product-info .cryo-plan-host',
      'product-info product-form',
      // Back-in-stock form (snippets/cryo-restock-form.liquid), shown only for a sold-out size (hidden, so ignored,
      // when in stock).
      'product-info [data-cryo-restock-form]',
      // "Try the other flavours" cross-sell cards (PDP CRO batch Task 1).
      '.cryo-xsell .card-wrapper',
    ],
    'cryo-cart-template': [
      '#main-cart-footer .cart__ctas',
      '#main-cart-footer .cart__dynamic-checkout-buttons',
    ],
    // Homepage hero: subheading, "Shop now", "Try all 3 flavours", the flavour tabs and the pause control.
    'cryo-index-template': [
      'cryo-hero .cryo-hero__sub',
      'cryo-hero .cryo-hero__btn',
      'cryo-hero .cryo-hero__link',
      'cryo-hero .cryo-hero__tabs',
      'cryo-hero .cryo-hero__pp',
    ].concat(CARDS),
    'cryo-collection-template': CARDS,
  };
  var body = document.body;
  var TARGETS = [];
  for (var key in TARGETS_BY_TEMPLATE) {
    if (body.classList.contains(key)) TARGETS = TARGETS.concat(TARGETS_BY_TEMPLATE[key]);
  }
  TARGETS = TARGETS.join(', ');
  var queued = false;
  var current = null;

  function hit(zone, el) {
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return zone.left < r.right && r.left < zone.right && zone.top < r.bottom && r.top < zone.bottom;
  }

  function check() {
    queued = false;
    var teaser = document.querySelector('[class*="kl-teaser-"]');
    if (teaser !== current) {
      // A new teaser: keep it hidden and without a transition until its hold state has been painted once.
      current = teaser;
      body.classList.remove('cryo-teaser-ready');
    }
    var hold = false;
    if (teaser && mq.matches && TARGETS) {
      var t = teaser.getBoundingClientRect();
      if (t.width > 0) {
        var zone = { left: t.left - 8, right: t.right + 8, top: t.top - 8, bottom: t.bottom + 8 };
        var targets = document.querySelectorAll(TARGETS);
        for (var i = 0; i < targets.length && !hold; i++) hold = hit(zone, targets[i]);
      }
    }
    body.classList.toggle('cryo-teaser-hold', hold);
    if (teaser && !body.classList.contains('cryo-teaser-ready')) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (current === teaser) body.classList.add('cryo-teaser-ready'); });
      });
    }
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  window.addEventListener('scroll', queue, { passive: true });
  // Scroll events of inner scrollers (the homepage card slider) don't bubble; catch them on the way down.
  document.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('resize', queue);
  if (mq.addEventListener) mq.addEventListener('change', queue);
  new MutationObserver(queue).observe(body, { childList: true, subtree: true });
  queue();
})();
